import { Upload } from 'antd'
import { twMerge } from "tailwind-merge";

export function SL_Upload({ className = '', children, ...rest }) {

    const classes = twMerge(`
        ${className ?? ''}
    `)

    return (
        <Upload {...rest} className={classes}>
            {children}
        </Upload>
    )
}
